import axios from "../plugins/axios";

async function getOrderById(orderId) {
  const res = await axios.get(`/qr-app/order/${orderId}`);
  return res.data;
}

// Order creation is deliberately NOT cancellable. The server writes the order
// and returns 201, so cancelling the request client-side cannot un-create it --
// it would only hide an order that exists from the guest, who would then very
// reasonably order again. If two taps ever get through, two orders is the
// honest outcome; a silently cancelled first request is not.
async function createOrder(payload) {
  const res = await axios.post(`/qr-app/order`, payload);
  return res.data;
}

async function createPayment(payload) {
  const res = await axios.post(`/qr-app/payment`, payload);
  return res.data;
}

const cartService = {
  createOrder,
  createPayment,
  getOrderById,
};

export default cartService;
